import type {
  IChatSubmissionEvent,
  IChatSubmissionInput,
} from '../types/clickEvents';

const chatSubmission = (
  input: IChatSubmissionInput,
): Omit<IChatSubmissionEvent, 'event'> => ({
  linkDetails: input.linkDetails,
  menuSelection: input.menuSelection,
});

export default chatSubmission;
